import React from 'react';
import moment from 'moment';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const cotacaoSchema = Yup.object().shape({
  bolsa: Yup.number()
    .typeError('Deve ser um número')
    .required('Bolsa é obrigatório')
    .min(0, 'Deve ser >= 0'),
  ny_spot: Yup.number()
    .typeError('Deve ser um número')
    .required('NY Spot é obrigatório')
    .min(0, 'Deve ser >= 0'),
  rep_dlp: Yup.number()
    .typeError('Deve ser um número')
    .required('Rep DLP é obrigatório')
    .min(0, 'Deve ser >= 0'),
  venda_dlp: Yup.number()
    .typeError('Deve ser um número')
    .required('Venda DLP é obrigatório')
    .min(0, 'Deve ser >= 0'),
  rep_dlcb: Yup.number()
    .typeError('Deve ser um número')
    .required('Rep DLCB é obrigatório')
    .min(0, 'Deve ser >= 0'),
  venda_dlcb: Yup.number()
    .typeError('Deve ser um número')
    .required('Venda DLCB é obrigatório')
    .min(0, 'Deve ser >= 0'),
  compra_au: Yup.number()
    .typeError('Deve ser um número')
    .required('Compra Au é obrigatório')
    .min(0, 'Deve ser >= 0'),
  venda_au: Yup.number()
    .typeError('Deve ser um número')
    .required('Venda Au é obrigatório')
    .min(0, 'Deve ser >= 0'),
  london_fix: Yup.number()
    .typeError('Deve ser um número')
    .required('London Fix é obrigatório')
    .min(0, 'Deve ser >= 0'),
  venda_dlc: Yup.number()
    .typeError('Deve ser um número')
    .required('Venda DLC é obrigatório')
    .min(0, 'Deve ser >= 0'),
});

const CAMPOS_COLUNA1 = [
  { name: 'bolsa', label: 'Bolsa' },
  { name: 'rep_dlp', label: 'Rep DLP' },
  { name: 'rep_dlcb', label: 'Rep DLCB' },
  { name: 'compra_au', label: 'Compra Au' },
  { name: 'london_fix', label: 'London Fix' },
];

const CAMPOS_COLUNA2 = [
  { name: 'ny_spot', label: 'NY Spot' },
  { name: 'venda_dlp', label: 'Venda DLP' },
  { name: 'venda_dlcb', label: 'Venda DLCB' },
  { name: 'venda_au', label: 'Venda Au' },
  { name: 'venda_dlc', label: 'Venda DLC' },
];

const getInitialValues = (cotacao) => {
  if (cotacao != null) {
    return {
      bolsa: cotacao.bolsa != null ? cotacao.bolsa : 0,
      ny_spot: cotacao.ny_spot != null ? cotacao.ny_spot : 0,
      rep_dlp: cotacao.rep_dlp != null ? cotacao.rep_dlp : 0,
      venda_dlp: cotacao.venda_dlp != null ? cotacao.venda_dlp : 0,
      rep_dlcb: cotacao.rep_dlcb != null ? cotacao.rep_dlcb : 0,
      venda_dlcb: cotacao.venda_dlcb != null ? cotacao.venda_dlcb : 0,
      compra_au: cotacao.compra_au != null ? cotacao.compra_au : 0,
      venda_au: cotacao.venda_au != null ? cotacao.venda_au : 0,
      london_fix: cotacao.london_fix != null ? cotacao.london_fix : 0,
      venda_dlc: cotacao.venda_dlc != null ? cotacao.venda_dlc : 0,
    };
  }
  return {
    bolsa: 0,
    ny_spot: 0,
    rep_dlp: 0,
    venda_dlp: 0,
    rep_dlcb: 0,
    venda_dlcb: 0,
    compra_au: 0,
    venda_au: 0,
    london_fix: 0,
    venda_dlc: 0,
  };
};

const ModalCotacao = (props) => {
  const show = props.show;
  const onHide = props.onHide;
  const cotacaoParaEditar = props.cotacaoParaEditar;
  const onSalvar = props.onSalvar;

  const ehEdicao = cotacaoParaEditar != null;
  const titulo = ehEdicao ? 'Alterar Cotação' : 'Incluir Cotação';

  const handleSubmit = async (values, formikBag) => {
    try {
      const payload = {
        data_cotacao: ehEdicao ? cotacaoParaEditar.data_cotacao : null,
        bolsa: Number(values.bolsa),
        ny_spot: Number(values.ny_spot),
        rep_dlp: Number(values.rep_dlp),
        venda_dlp: Number(values.venda_dlp),
        rep_dlcb: Number(values.rep_dlcb),
        venda_dlcb: Number(values.venda_dlcb),
        compra_au: Number(values.compra_au),
        venda_au: Number(values.venda_au),
        london_fix: Number(values.london_fix),
        venda_dlc: Number(values.venda_dlc),
      };
      await api.gravarCotacao(payload);
      toast.success(ehEdicao ? 'Cotação alterada com sucesso.' : 'Cotação incluída com sucesso.');
      onSalvar();
    } catch (err) {
      toast.error((err && err.message) ? err.message : 'Erro ao salvar cotação.');
    } finally {
      formikBag.setSubmitting(false);
    }
  };

  const renderCampo = (formik, campo) => (
    <Form.Group className="mb-2" key={campo.name}>
      <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.82rem' }}>
        {campo.label} <span className="text-danger">*</span>
      </Form.Label>
      <Form.Control
        type="number"
        step="0.0001"
        name={campo.name}
        value={formik.values[campo.name]}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        isInvalid={formik.touched[campo.name] && !!formik.errors[campo.name]}
        style={{ fontSize: '0.85rem' }}
      />
      <ErrorMessage
        name={campo.name}
        component="div"
        className="invalid-feedback d-block"
        style={{ fontSize: '0.75rem' }}
      />
    </Form.Group>
  );

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
          {titulo}
        </Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={getInitialValues(cotacaoParaEditar)}
        validationSchema={cotacaoSchema}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
      >
        {(formik) => (
          <Form onSubmit={formik.handleSubmit}>
            <Modal.Body>
              {ehEdicao && (
                <Form.Group className="mb-3">
                  <Form.Label className="mb-1 font-weight-bold" style={{ fontSize: '0.82rem' }}>
                    Data Cotação
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={moment(cotacaoParaEditar.data_cotacao).format('DD/MM/YYYY HH:mm')}
                    readOnly
                    disabled
                    style={{ backgroundColor: '#f5f5f5', fontSize: '0.85rem', maxWidth: 200 }}
                  />
                </Form.Group>
              )}

              <Row>
                <Col xs={12} sm={6}>
                  {CAMPOS_COLUNA1.map((campo) => renderCampo(formik, campo))}
                </Col>
                <Col xs={12} sm={6}>
                  {CAMPOS_COLUNA2.map((campo) => renderCampo(formik, campo))}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <Button variant="secondary" onClick={onHide} disabled={formik.isSubmitting}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit" disabled={formik.isSubmitting}>
                {formik.isSubmitting ? 'Gravando...' : 'Gravar'}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default ModalCotacao;
